<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="筛选学校">
                        <el-select v-model="filter.school_id" clearable placeholder="请选择学校" filterable remote
                                   :remote-method="handleSearchSchool" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in schools"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选年级">
                        <el-select v-model="filter.grade_id" clearable placeholder="请选择年级" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选班主任">
                        <el-select v-model="filter.headTeacher_id" clearable placeholder="请选择班主任" filterable remote
                                   :remote-method="handleSearchHeadTeacher" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in headTeachers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="筛选学号">
                        <el-select v-model="filter.student_id" clearable placeholder="请选择学号" filterable remote
                                   :remote-method="handleSearchStudentId" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in student_ids"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选学生手机号">
                        <el-select v-model="filter.student_phone_id" clearable placeholder="请选择学生手机号" filterable remote
                                   :remote-method="handleSearchStudentPhone" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in phones"
                                    :key="item.id"
                                    :label="item.phone"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选学生姓名">
                        <el-select v-model="filter.student_name_id" clearable placeholder="请选择学生姓名" filterable remote
                                   :remote-method="handleSearchStudentName" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in students"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态筛选">
                        <el-select v-model="filter.status"
                                   multiple
                                   clearable
                                   placeholder="请选择"
                                   @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in specialTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right m-b-0">
<!--            <div>-->
<!--                <el-button @click="handleStoreDeposit">添加学生押金</el-button>-->
<!--                &lt;!&ndash;<el-button @click="handleStoreElectronicInvoice">添加电子合同</el-button>&ndash;&gt;-->
<!--            </div>-->
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderStudentDeposits"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-20"
                          size="middle">
                    <el-table-column prop="student_id" label="学号" min-width="5%"></el-table-column>
                    <el-table-column prop="name" label="姓名" min-width="5%"> </el-table-column>
                    <el-table-column label="学校" min-width="10%">
                        <template slot-scope="scope">
                            <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.school.name}}</span>
                            <span v-else>学校未添加</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="年级" min-width="5%">
                        <template slot-scope="scope">
                            <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.grade.name}}</span>
                            <span v-else>年级未添加</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone" label="学生联系方式" min-width="10%"></el-table-column>
                    <el-table-column label="家长姓名" min-width="15%">
                        <template slot-scope="scope">
                            <p v-for="parent in scope.row.parents" :key="parent.id">
                                <span>{{parent.parent_identity}}： {{parent.name}}</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="家长联系方式" min-width="10%">
                        <template slot-scope="scope">
                            <p v-for="parent in scope.row.parents" :key="parent.id">
                                <span>{{parent.phone}}</span>
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="班主任" min-width="10%">
                        <template slot-scope="scope">
                            <span v-for="(headTeacher,index) in scope.row.headTeachers" :key="index"> {{headTeacher.name}} </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="balance" label="金额" min-width="5%">
                    </el-table-column>
                    <el-table-column prop="status_name" label="状态" min-width="5%">
                    </el-table-column>
                    <el-table-column label="操作" v-if="powers.includes(2)" min-width="10%">
                        <template slot-scope="scope">
                            <el-dropdown trigger="click" size="medium">
                                <el-button icon="el-icon-edit">修改状态</el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleChangeStatus(scope.row.id,'active')">抵押中</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleChangeStatus(scope.row.id,'canUse')">可使用</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleChangeStatus(scope.row.id,'cancel')">已退</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleChangeStatus(scope.row.id,'used')">已使用</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path: '/student/deposit/list',
                loading: true,
                studentDeposits: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                semesters: [],
                phones: [],
                student_ids: [],
                headTeachers: [],
                students: [],
                schools: [],
                grades: [],
                specialTypes:[
                    {
                        value: 'active',
                        label: '抵押中'
                    },
                    {
                        value: 'canUse',
                        label: '可使用'
                    },
                    {
                        value: 'cancel',
                        label: '已退'
                    },
                    {
                        value: 'used',
                        label: '已使用'
                    },
                ],
                filter:{
                    grade_id: '',
                    school_id: '',
                    headTeacher_id: '',
                    student_id: '',
                    student_name_id: '',
                    student_phone_id:'',
                    status:[],
                },
                dialog_StoreStudentDeposit:{
                    filter:{
                        grade_id: '',
                        school_id: '',
                        headTeacher_id: '',
                        student_id: '',
                        student_name_id: '',
                        student_phone_id:'',
                        remark:'',
                        balance:''
                    },
                    button_loading:false,
                }
            }
        },
        props: {},
        components: {},
        created() {
            this.handleInit();
            this.handleIndexStudent();
            this.handleCreate();

        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            orderStudentDeposits: function () {
                return this._.values(this.studentDeposits);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.semesters = data.semesters;
                        this.grades = data.grades;
                        this.schools = data.schools;
                        this.headTeachers =  data.headTeachers;
                        this.students =  data.students;
                        this.student_ids =  data.student_ids;
                        this.phones =  data.phones;
                        break;
                    case 'list':
                        if (Object.keys(data.studentDeposits).length > 0) {
                            this.studentDeposits = data.studentDeposits;
                        } else {
                            this.studentDeposits = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'searchSchool':
                        this.schools = data.searchData;
                        break;
                    case 'searchHeadTeacher':
                        this.headTeachers = data.searchData;
                        break;
                    case 'searchStudentId':
                        this.student_ids = data.searchData;
                        break;
                    case 'searchStudentName':
                        this.students = data.searchData;
                        break;
                    case 'searchStudentPhone':
                        this.phones = data.searchData;
                        break;
                    case 'changeStatus':
                        this.$set(this.studentDeposits,data.studentDeposit.id,data.studentDeposit)
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        break;
                    case 'searchStudent':
                        this.students=data.searchData
                        break;
                    case 'store_student_deposit':
                        this.$set(this.studentDeposits,data.studentDeposit.id,data.studentDeposit)
                        this.total++;
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        });
                        break;
                }
            },
            handleInit() {
                this.$wApi.send(this.path, 'init', {})
            },
            handleIndexStudent(currentPage=1) {
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter': this.filter,
                });
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type':'searchSchool',
                    'schoolKeyName': query,
                })
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type':'headTeacherKeyName',
                    'headTeacherKeyName': query,
                })
            },
            handleSearchStudentId(query){
                this.$wApi.send(this.path, 'search', {
                    'type':'studentKeyId',
                    'studentKeyId': query,
                })
            },
            handleSearchStudentName(query){
                this.$wApi.send(this.path, 'search', {
                    'type':'studentKeyName',
                    'studentKeyName': query,
                })
            },
            handleSearchStudentPhone(query){
                this.$wApi.send(this.path, 'search', {
                    'type':'studentKeyPhone',
                    'studentKeyPhone': query,
                })
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexStudent(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexStudent(this.currentPage)
            },
            handleChangeStatus(balance_id,status){
                this.$confirm('确认修改状态?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'changeStatus', {
                        'balance_id':balance_id,
                        'status': status,
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

            },
            handleStoreDeposit(){
                this.$Win.openModal('Dialog_StoreStudentDeposit', 400, 500, '添加押金', {});
            },
            handleStoreElectronicInvoice(){
                this.$Win.openModal('Dialog_TeachingEquipmentReturn', 760, 800, '生成合同', {});
            }
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
